/**
 * @generated SignedSource<<1ce702deabf786e85957bdfca2bc8e8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CodepushSeverityEnum = "tier1" | "tier2" | "tier3" | "%future added value";
export type CodepushVersionStatusEnum = "production" | "staging" | "%future added value";
export type CodepushVersionUpdateInput = {
  id: string;
  severity?: CodepushSeverityEnum | null;
  status?: CodepushVersionStatusEnum | null;
  title?: string | null;
};
export type CodepushVersionUpdateDialog_codepushVersionUpdateMutation$variables = {
  input: CodepushVersionUpdateInput;
};
export type CodepushVersionUpdateDialog_codepushVersionUpdateMutation$data = {
  readonly codepushVersionUpdate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CodepushVersionUpdateDialog_codepushVersion">;
  };
};
export type CodepushVersionUpdateDialog_codepushVersionUpdateMutation = {
  response: CodepushVersionUpdateDialog_codepushVersionUpdateMutation$data;
  variables: CodepushVersionUpdateDialog_codepushVersionUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CodepushVersionUpdateDialog_codepushVersionUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CodepushVersionUpdateDialog_codepushVersion"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodepushVersionUpdateDialog_codepushVersionUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CodepushVersion",
        "kind": "LinkedField",
        "name": "codepushVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "severity",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "edffbd2e5ec92f625e71c89ebfe0f8b7",
    "id": null,
    "metadata": {},
    "name": "CodepushVersionUpdateDialog_codepushVersionUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CodepushVersionUpdateDialog_codepushVersionUpdateMutation(\n  $input: CodepushVersionUpdateInput!\n) {\n  codepushVersionUpdate(input: $input) {\n    id\n    ...CodepushVersionUpdateDialog_codepushVersion\n  }\n}\n\nfragment CodepushVersionUpdateDialog_codepushVersion on CodepushVersion {\n  id\n  title\n  severity\n}\n"
  }
};
})();

(node as any).hash = "5ed7c8bdab7a85b7b816d8517ad59ccf";

export default node;
